<template>
  <div class="notice-detail min-height">
    <div class="padding">
      <h3 class="detail-title">{{ title }}</h3>
      <p class="detail-time">发布时间：{{ time }}</p>

      <div class="detail-html" v-html="content"></div>
      <div class="flex-list margin-top" v-if="attached_file.length > 0">
        附件：
        <p v-for="(item, index) in attached_file" :key="index">
          <el-link type="primary" :href="showhost + item.url" target="_blank">{{
            item.name
          }}</el-link>
        </p>
      </div>
      <div class="feedback" v-if="notice_type === 2 && !replyInfo">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="反馈内容：" prop="desc">
            <el-input
              type="textarea"
              rows="6"
              v-model="ruleForm.desc"
            ></el-input>
          </el-form-item>
          <el-form-item label="反馈附件：" prop="other">
            <el-upload
              ref="upload3"
              :action="udhost + '/api/index/upload'"
              :name="'file'"
              :data="fileData"
              :file-list="fileList3"
              :on-preview="handlePreview"
              :on-remove="handleRemove3"
              :on-success="handleAvatarSuccess3"
            >
              <div class="flex align-center">
                <el-button type="primary" plain> + 点击上传附件</el-button>
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label-width="0">
            <div class="flex align-center justify-around">
              <el-button
                class="set-btn"
                type="primary"
                @click="submitData('ruleForm')"
                >立即反馈</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </div>

      <div class="feedback" v-if="notice_type === 2 && replyInfo">
        <el-form label-width="100px" class="demo-ruleForm">
          <el-form-item label="反馈内容：">
            <div>{{ replyInfo.content }}</div>
          </el-form-item>
          <el-form-item label="反馈附件：">
            <el-link
              type="primary"
              :href="replyInfo.attached_file.url"
              target="_blank"
              >{{ replyInfo.attached_file.name }}</el-link
            >
          </el-form-item>
        </el-form>
        <div class="flex align-center justify-around">
          <el-button class="set-btn" type="info">已反馈</el-button>
        </div>
      </div>

      <div
        class="flex align-center justify-around margin"
        v-if="notice_type === 3 && signUpInfo.length < signup_num"
      >
        <el-button class="set-btn" type="primary" @click="sginDialag = true">立即报名</el-button>
      </div>
      <div
        class="flex align-center justify-around margin"
        v-if="notice_type === 3 && signUpInfo.length >= signup_num"
      >
        <el-button class="set-btn" type="info">已报名</el-button>
      </div>

      <div v-if="signUpInfo.length > 0">
        <h3 class="margin-bottom-sm">已报名信息：</h3>
        <div class="flex align-start">
          <div
            v-for="(item, index) in signUpInfo"
            :key="index"
            class="sign-item"
          >
            <p>联系人：<span>{{ item.tel_name }}</span></p>
            <p>联系人电话：<span>{{ item.tel_number }}</span></p>
            <p>报名时间：<span>{{ item.create_time }}</span></p>
            <p v-for="(items, j) in item.diy_from" :key="j">
              {{ items.name }}：
              <span v-if="Number(items.type) !== 4">{{ items.value }}</span>
              <span v-if="Number(items.type) === 4">
                <i v-for="(option,op) in items.value" :key="op">
                  {{option}} <br/>
                </i>
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>

    <sign-up :sginDialag="sginDialag" @cancelDialog="cancelDialog" />
  </div>
</template>

<script>
import signUp from '@/views/member/children/signUp'
import { SHOWHOST, UDHOST } from '@/config/index'
import { noticeDetail, noticeReplyAddMember } from '@/api/member'
export default {
  name: "noticeDetail",
  data () {
    return {
      title: '',
      time: '',
      content: '',
      notice_type: '',
      attached_file: [],
      ruleForm: {
        desc: '',
        other: [],

      },
      rules: {
        desc: [
          { required: true, message: '请填写反馈内容', trigger: 'blur' }
        ]
      },
      fileList3: [],
      replyInfon: null,
      signup_num: 1,
      signUpInfo: [],
      sginDialag: false
    }
  },
  computed: {
    udhost () {
      return UDHOST
    },
    showhost () {
      return SHOWHOST
    },
    fileData () {
      return {
        // token: this.user.token
      };
    },
    user () {
      return this.$store.state.user
    },
  },
  created () {
    this.$emit("setIndex", '/home/notice', "通知公告  / 详情 ", true, 'icon-gonggao');
    this.getDetail()
  },
  components: {
    signUp
  },
  methods: {
    cancelDialog () {
      this.sginDialag = false
      this.getDetail()
    },
    submitData (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.sureSubmit()
        } else {
          this.$message.error('请填写反馈内容')

        }
      });
    },
    async sureSubmit () {
      let _state = await noticeReplyAddMember(this.$route.params.id, this.ruleForm.desc, JSON.stringify(this.ruleForm.other))
      if (_state.status === 200) this.$message.success('反馈成功'), this.getDetail()
    },



    handleRemove3 (file, fileList) {
      this.infoForm.other = fileList
      this.fileList3 = fileList
    },
    handleAvatarSuccess3 (res, file) {
      if (res.status === 200) {
        this.ruleForm.other = {
          name: file.name,
          url: res.url
        }

        this.fileList3 = [this.ruleForm.other]
      } else {
        this.$message.error(res.info)
        this.$refs['upload'].clearFiles()
      }
    },
    // 上传失败
    handleExceed () {
      this.$message.error('请先删除当前已上传的文件')
    },
    //上传文件预览
    handlePreview (file) {
      window.open(file.url)
    },
    async getDetail () {
      let _data = await noticeDetail(this.$route.params.id)
      if (_data.data.replyInfo) _data.data.replyInfo.attached_file = JSON.parse(_data.data.replyInfo.attached_file)
      this.title = _data.data.title
      this.time = _data.data.create_time
      this.content = _data.data.content
      this.notice_type = _data.data.notice_type
      this.replyInfo = _data.data.replyInfo
      this.signup_num = _data.data.signup_num

      this.attached_file = JSON.parse(_data.data.attached_file)
      if (_data.data.signUpInfo) {
        _data.data.signUpInfo.map(item => {
          item.diy_from = JSON.parse(item.diy_from)
        })
        this.signUpInfo = _data.data.signUpInfo
      } else {
        this.signUpInfo = []
      }



    }
  },
  filters: {},
  watch: {},
}
</script>

<style scoped lang="scss">
.notice-detail {
  .detail-title {
    font-size: 26px;
    line-height: 40px;
    margin-bottom: 5px;
  }
  .detail-time {
    color: #999;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #ccc;
  }
  .set-btn {
    width: 200px;
  }
  .feedback {
    border: 1px solid #ccc;
    padding: 30px;
    margin-top: 30px;
    border-radius: 10px;
  }
  .flex-list {
    p {
      margin-top: 5px;
    }
  }
}
.sign-item {
  border: 1px solid #ccc;
  padding: 20px;
  width: 32%;
  margin-right: 30px;
  p {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    line-height: 200%;
    font-size: 16px;
    border-bottom: 1px dashed #ccc;
    padding: 5px;
    span{
      width: 60%;
      text-align: right;
    }
  }
}
</style>